import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            为什么千万观众选择爱豆影视？四大核心优势为您保驾护航
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="group p-6 md:p-7 bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-500/20 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-500/10 mb-4 group-hover:bg-accent-500/20 transition-colors">
                <i className={`${feature.icon} text-xl text-accent-500`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}